const RegisterUser = () => {
  return (
    <>
      <div className="containers d-flex align-item-center py-2 main_header justify-content-center mt-5 pt-5 login_card">
        <div className="card col-12 col-sm-8 col-lg-4">
          <img
            src="assets/img/logo.png"
            className="card-img-top logo px-4 py-3"
            alt="logo"
          />
          <div className="card-body border-top">
            <form className="px-4 py-3 grid-form">
              <div className="form-floating ">
                <input
                  type="email"
                  className="form-control"
                  id="floatingInput"
                  placeholder="name@example.com"
                />
                <label htmlFor="floatingInput">First Name</label>
              </div>

              <div className="form-floating ">
                <input
                  type="email"
                  className="form-control"
                  id="floatingInput"
                  placeholder="name@example.com"
                />
                <label htmlFor="floatingInput">Last Name</label>
              </div>
              <div className="full-row">
                <div className="form-floating ">
                  <input
                    type="email"
                    className="form-control"
                    id="floatingInput"
                    placeholder="name@example.com"
                  />
                  <label htmlFor="floatingInput">Email</label>
                </div>
              </div>
              <div className="form-floating ">
                <input
                  type="password"
                  className="form-control"
                  id="floatingInput"
                  placeholder="name@example.com"
                />
                <label htmlFor="floatingInput">Password</label>
              </div>
              <div className="form-floating ">
                <input
                  type="password"
                  className="form-control"
                  id="floatingInput"
                  placeholder="name@example.com"
                />
                <label htmlFor="floatingInput">RePassword</label>
              </div>

              <div className="full-row">
                <button type="submit" className="btn btn-primary mb-3 w-100">
                  Continue
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterUser;
